<template>
  <el-dialog top="10px"
    :title="isEdit ? '修改' : '新增'"
    :visible.sync="isVisible"
    width="300px"
    :close-on-click-modal="false" :close-on-press-escape="false" :fullscreen="false" :append-to-body="true">

    <el-form
      ref="categoryForm"
      :model="categoryForm"
      :rules="categoryRules"
      label-position="top"
      autocomplete="off"
    >
      <el-form-item prop="category" label="名称">
        <el-input
          v-model="categoryForm.category"
          size="medium"
          clearable
          placeholder="请输入"
          autocomplete="off"
          @keyup.enter.native="handleConfirm"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button class="btn" @click="handleConfirm" >
        确定
      </el-button>
      <el-button @click="isVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>


<script>

export default {
  name: "CommonCatInput",
  data() {
    const validateCategory = (rule, value, callback) => {
      if (value == null || value === "" || typeof (value) == "undefined") {
        callback(new Error("请输入分类名称"));
      } else {
        callback();
      }
    };
    return {
      type: null,
      name: "",
      value: null,
      isEdit: false,
      isVisible: false,
      categoryForm: {
        category: null,
        categoryId: null
      },
      categoryRules: {
        category: [
          {required: true, trigger: 'blur', validator: validateCategory}
        ],
      },
    }
  },
  mounted: function () {
  },
  methods: {
    initialAdd: function (add_url) {
      this.handleReset();
      this.isVisible = true;
      this.isEdit = false;
      this.categoryForm.category = null;
      this.add_url = add_url;
    },
    initial: function (t, add_url) {
      this.handleReset();
      this.isVisible = true;
      this.add_url = add_url;
      this.isEdit = true;
      this.categoryForm.category = t.title;
      this.categoryForm.categoryId = t.itemId;
    },
    handleConfirm() {

      let t = this;
      this.$post(
        {
          context: t,
          path: t.add_url,
          params: {
            title: t.categoryForm.category,
            item_id: t.isEdit ? t.categoryForm.categoryId : 0,
          },
          success: function (data) {
            t.$message.success("操作成功");
            t.$emit("refresh");
            t.isVisible = false;
          }
        }
      )

    },
    handleReset() {
      //this.$refs.categoryForm.resetFields()
    },
  },
}
</script>

<style scoped>
@import '../assets/global.css';
</style>
